import { useForm } from 'react-hook-form';
import { Checkbox, FormProvider, SelectTag, TextField } from '../../../../../components';
import { Button, Grid, Stack, Typography } from '@mui/material';
import {
  MEDICINE_DOSE,
  MEDICINE_FREQUENCY,
  MEDICINE_NAME,
  MEDICINE_UNIT,
  OCCUPY_STATUS,
  YES_NO
} from '../../../../../constants';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { useEffect } from 'react';
import { useRef } from 'react';

export const DiseaseDetailsForm = ({ onAdd, onClose, editData, isEditMode,setAddDiseaseDialogueOpen }) => {
  const diagnosRef = useRef();
  const methods = useForm({
    resolver: yupResolver(
      Yup.object().shape({
        disease_type: Yup.string().required(' ')
      })
    ),
    mode: 'all'
  });
  const { handleSubmit, reset } = methods;
  const formSubmit = (formValue) => {
    onAdd(formValue)
    setAddDiseaseDialogueOpen(false)
  };





  return (
    <FormProvider methods={methods} onSubmit={handleSubmit(formSubmit)}>
     <Grid item xs={12} sx={{ display: 'flex', flexDirection: 'column', gap: 2, marginLeft: '1%' }}>
  <Stack spacing={2}>
    <Stack spacing={0.5} direction="row" alignItems="center" sx={{ width: '100%' }}>
      <Typography sx={{ flex: 0.4, fontWeight: 600, fontSize: '1.4rem' }}>Disease Type</Typography>
      <TextField sx={{ flex: 1 }} name="disease_type" placeholder="Enter Disease Type" />
    </Stack>
    
    <Stack spacing={0.5} direction="row" alignItems="center" sx={{ width: '100%' }}>
      <Typography sx={{ flex: 0.4, fontWeight: 600, fontSize: '1.4rem' }}>Duration</Typography>
      <TextField sx={{ flex: 1 }} name="duration" placeholder="Duration" />
    </Stack>

    <Stack spacing={0.5} direction="row" alignItems="center" sx={{ width: '100%' }}>
      <Typography sx={{ flex: 0.4, fontWeight: 600, fontSize: '1.4rem' }}>Unit</Typography>
      <TextField sx={{ flex: 1 }} name="unit" placeholder="Enter Unit" />
    </Stack>

    <Stack spacing={0.5} direction="row" alignItems="center" sx={{ width: '100%' }}>
      <Typography sx={{ flex: 0.4, fontWeight: 600, fontSize: '1.4rem' }}>Description</Typography>
      <TextField sx={{ flex: 1 }} name="description" placeholder="Description" />
    </Stack>
  </Stack>
</Grid>

      <Stack spacing={1} direction="row" alignItems="center" justifyContent="flex-end" marginTop="5%">
        <Button variant="contained" type="submit">
          Add
        </Button>
        <Button color="error" onClick={onClose}>
          Close
        </Button>
      </Stack>
    </FormProvider>
  );
};
